import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { ReviewMethod, reviewPriceSchemeImport } from 'src/api/reviewPriceSchemeImport/reviewPriceSchemeImport';
import { QueryKeys } from '../QueryKeys';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';

export const useReviewPriceImport = (eventId: string) => {
  const { showSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, ReviewMethod>((method) => reviewPriceSchemeImport(eventId, method), {
    onSuccess: async (_, method) => {
      showSnackbar({
        message: `Price Scheme ${method === 'PATCH' ? 'accepted' : 'rejected'}.`,
        status: SnackbarStatus.SUCCESS,
      });

      await queryClient.refetchQueries({ queryKey: [QueryKeys.priceSchemes, getBrandId()] });
    },
    onError: () => {
      showSnackbar({
        message: 'Failed to process price scheme, please try again',
        status: SnackbarStatus.ERROR,
      });
    },
  });
};
